import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_VGS: TStep[] = [
  {
    pageId: PageId.DOG_AGE_VGS,
  },
  {
    pageId: PageId.SEX_VGS,
  },
  {
    pageId: PageId.URGE_VGS,
  },
  {
    pageId: PageId.OTHER_DOGS_VGS,
  },
  {
    pageId: PageId.NOISES_VGS,
  },
  {
    pageId: PageId.LEASH_PULLING_VGS,
  },
  {
    pageId: PageId.BARKS_VGS,
  },
  {
    pageId: PageId.OUT_OF_CONTROL_VGS,
  },
  {
    pageId: PageId.URGE_2_VGS,
  },
  {
    pageId: PageId.BEHAVIOR_VGS,
  },
  {
    pageId: PageId.TRIGGERS_VGS,
  },
  {
    pageId: PageId.CALM_DOWN_VGS,
  },
  {
    pageId: PageId.URGE_4_VGS,
  },
  {
    pageId: PageId.DOG_REACT_VGS,
  },
  {
    pageId: PageId.URGE_TOUCH,
  },
  {
    pageId: PageId.DOG_ACT_VGS,
  },
  {
    pageId: PageId.DOG_OFF_AT_HOME_VGS,
  },
  {
    pageId: PageId.AGGRESSIVE_VGS,
  },
  {
    pageId: PageId.DOG_IGNORED_VGS,
  },
  {
    pageId: PageId.DOG_BREED_VGS,
  },
  {
    pageId: PageId.LOADER_SCREEN_VGS,
  },
  {
    pageId: PageId.DOG_STATISTICS_VGS,
  },
  {
    pageId: PageId.TIME_VGS,
  },
  {
    pageId: PageId.URGE_5_VGS,
  },
  {
    pageId: PageId.PREPARE_FLOW_VGS,
  },
  {
    pageId: PageId.EMAIL_VGS,
  },
  {
    pageId: PageId.NEWSLETTER_VGS,
  },
  {
    pageId: PageId.PERSONALIZED_PLAN_VGS,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_VGS,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_VGS,
  },
  {
    pageId: PageId.UPSELL_VGS,
  },
  {
    pageId: PageId.CHAT_UPSELL_VGS,
  },
  {
    pageId: PageId.DOWNLOAD_VGS,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_VGS.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_VGS.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
